import { render, staticRenderFns } from "./MyRegistrationsInfo.vue?vue&type=template&id=0a4129a5"
import script from "./MyRegistrationsInfo.vue?vue&type=script&lang=js"
export * from "./MyRegistrationsInfo.vue?vue&type=script&lang=js"
import style0 from "./MyRegistrationsInfo.vue?vue&type=style&index=0&id=0a4129a5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports